<template>
    <div class="mb-8">
        <FormKit
            type="form"
            :actions="false"
            :incomplete-message="false"
            v-slot="{ state: { valid } }"
            @submit="handleSubmit"
        >
            <div class="md:flex md:align-top">
                <div
                    class="h-11 w-full flex justify-between relative after:content-[''] after:absolute after:bottom-0 after:w-[calc(100%-2.3rem)] after:border-b after:border-bbk-off-black mb-4 md:mb-0 md:order-2 md:ml-4"
                    :class="!valid && 'after:border-bbk-grey'"
                >
                    <FormKit
                        :classes="{
                            input: ' py-2.5 w-full !bg-bbk-off-white autofill:bg-white -webkit-autofill:bg-white rounded-none border-0 appearance-none focus:!ring-0 focus:border-0 peer text-center',
                            outer: 'w-full text-black formkit-data-invalid:text-bbk-claret',
                            label: 'pointer-events-none transition-all duration-[0.2s] ease-[ease-out] delay-[0s] delay-[0.1s] formkit-has-value:opacity-0 absolute left-1/2 top-1/2 translate-x-[-75%] translate-y-[-50%]',
                            message: 'text-bbk-claret text-2xs text-right lowercase',
                        }"
                        type="text"
                        name="city"
                        :label="$t('Bbk.storeLocatorPoint.city')"
                        validation="required"
                        :validation-messages="{
                            required: $t('Bbk.storeLocatorPoint.cityInputValidationMessage'),
                        }"
                    />

                    <ShcUiButton
                        :modifier="BUTTON_MODIFIER.circular"
                        :size="BUTTON_SIZE.normal"
                        class="bg-black basis-auto grow-0 shrink-0 disabled:bg-bbk-grey absolute top-[-4px]"
                        :disabled="!valid"
                        type="submit"
                    >
                        <ShcUiIcon name="arrow_forward" class="text-2xl" />
                    </ShcUiButton>
                </div>

                <div
                    class="min-w-[244px] md:order-1 h-11 flex justify-between relative after:content-[''] after:absolute after:bottom-0 after:w-full after:border-b after:border-bbk-off-black"
                >
                    <FormKit
                        :classes="{
                            input: ' py-2.5 w-full !bg-bbk-off-white autofill:bg-white -webkit-autofill:bg-white rounded-none border-0 appearance-none focus:!ring-0 focus:border-0 peer',
                            outer: 'w-full',
                        }"
                        v-model="radiusSelectValue"
                        type="select"
                        name="radius"
                        :options="radiusSelectOptions"
                        class="w-[244px]"
                    />
                </div>
            </div>
        </FormKit>
    </div>
</template>

<script setup lang="ts">
    import type { formData } from '../../types/formData'

    import { BUTTON_MODIFIER, BUTTON_SIZE } from '@/components/Shc/Ui/Button/button'
    import radiusSelectOptions from '../../config/radiusSelectOptions'

    const { $bus } = useNuxtApp()

    const radiusSelectValue = ref('100')

    function handleSubmit(formData: formData) {
        $bus.$emit('mapCitySearch', formData)
    }
</script>
